<script setup lang="ts">
import { ref, watch } from 'vue';

import { BubbleQuestionIcon } from '@thehotelsnetwork/icons/vue/linear';

import { useUserMenu } from '@/composition/useUserMenu';

const menuSections = useUserMenu();

const isAsideExpanded = ref(true);

const initAppCues = () => {
  if (window.Appcues) {
    window.Appcues.show('1af3e0c4-f4f2-4596-9016-24c0d47665bd');
  }
};

watch(isAsideExpanded, (newVal) => {
  const asideWidth = newVal ? '16rem' : '4rem';
  document.documentElement.style.setProperty('--aside-desk-width', asideWidth);
});
</script>

<template>
  <LpAside
    :model-value="isAsideExpanded"
    :menu-sections="menuSections"
    class="aside"
    data-testid="aside-menu"
    @update:model-value="isAsideExpanded = $event"
  >
    <template #default="{ menuItem }">
      <router-link
        v-slot="{ navigate, href, isActive }"
        :to="menuItem.to"
        custom
      >
        <LpMainmenuBtn
          :active="isActive"
          :href="href"
          color="primary"
          :data-testid="`aside-menu-${menuItem.text}`"
          @click="navigate"
        >
          {{ menuItem.text }}
        </LpMainmenuBtn>
      </router-link>
    </template>

    <template #footerAction>
      <LpButton
        mode="transparent"
        size="medium"
        color="gray"
        tag="a"
        @click="initAppCues"
      >
        <span
          class="flex items-center space-x-2"
        >
          <BubbleQuestionIcon class="w-4 h-4 text-base-700" />
          <span class="text-sm font-bold text-base-700">{{ $t('Take a tour') }}</span>
        </span>
      </LpButton>
    </template>
  </LpAside>
</template>
